import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export interface InfoRow {
    label: string;
    value: string | null | undefined;
}

@Component({
    selector: 'bucke-property-list',
    templateUrl: './property-list.component.html',
    styleUrl: './property-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyListComponent {
    rows = input.required<InfoRow[]>();
    titleRow = input<InfoRow>();
}
